import { IconChevronDown } from '@tabler/icons-react';
import React from 'react';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { Select } from 'opencare-crown';

const typographyStyles = css`
${TYPOGRAPHY.CIRCULAR.book}
  color: ${BRAND_COLORS.darkGray};
  font-size: 16px;
  line-height: 24px;
`;

export const StyledSelect = styled(Select).attrs((props) => ({
  // Causes the popup to be rendered as a child of the trigger node,
  // which allows us to style it
  getPopupContainer: (triggerNode: HTMLElement) => triggerNode.parentElement,
  required: props.required,
  tabIndex: 0,
  size: 'large',
  bordered: true,
  showSearch: false,
  listHeight: 282, // Equivalent to max-height. 282px is ~8 options
  suffixIcon: <IconChevronDown size={16} color={BRAND_COLORS.darkGray} />,
  dropdownStyle: {
    borderRadius: '8px',
    border: `1px solid ${BRAND_COLORS.darkGray}`,
  },
}))`
  width: 100%;

  border-radius: 8px;

  &:focus-visible,
  &:focus-within {
    border-color: ${BRAND_COLORS.darkGreen};
    outline: none !important; /* antd uses !important so we have to as well */
  }

  /* Selected item styles */
  && {
    && {
      .ant-select-selector {
        height: 48px;
        width: 100%;
        padding: 12px;
        overflow: hidden;
        border-radius: 8px;
        border-color: ${BRAND_COLORS.stroke};

        ${({ $isInvalid }) => $isInvalid && css`
          border-color: ${BRAND_COLORS.darkRed};
        `}

        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          ${typographyStyles}
          height: fit-content;
        }

        .ant-select-selection-placeholder {
          color: ${BRAND_COLORS.darkStroke};
        }

        .ant-select-selection-search {
          display: none;
        }
      }
    }
  }

  /* Arrow styles */
  && {
    && {
      .ant-select-arrow {
        /* This is set up to cover any text that could overlap the arrow */
        position: absolute;
        height: calc(100% - 2px);
        width: 24px;
        top: 1px;
        right: 1px;

        display: flex;
        justify-content: center;
        align-items: center;

        background-color: ${BRAND_COLORS.white};

        margin-top: 0;
        border-radius: 0 8px 8px 0;
      }
    }
  }

  /* Option styles */
  .ant-select-item.ant-select-item-option {
    ${typographyStyles}

    padding: 0 12px;
    background: 0;

    &:hover {
      background-color: ${BRAND_COLORS.dirtyWhite};
    }
    &.ant-select-item-option-selected {
      background-color: ${BRAND_COLORS.ashGreen};
    }
  }

  /* Group styles */
  .option-group {
    padding: 0;
    background: 0;
  }
`;
